<template>
    <div>
        <header class="page-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Отчеты</h2>
                    </div>
                </div>
                <form @submit.prevent="reportDownload">
                    <div class="row pb-3">

                        <div class="col-3">

                            <div class="trn-search-label">Фильтр</div>

                            <div class="row">

                                <div class="col-12">
                                    <div class="form-group">
                                        <app-datepicker-filter v-model="dateRange"></app-datepicker-filter>
                                        <span class="small" style="color: red" v-if="dateRange === null">Пожалуйста, выберите дату</span>
                                    </div>

                                    <div class="form-group">
                                            <select class="form-control" v-model="formData.type">
                                                <option value="">-- Тип платежа --</option>
                                                <option v-for="(key, value) in types" :value="value">{{ key }}</option>
                                            </select>
                                    </div>

                                    <div class="form-group">
                                        <select class="form-control" v-model="formData.merchant_id">
                                            <option value="">-- Выберите мерчанта --</option>
                                            <option v-for="merchant in merchants" :value="merchant.id">{{ merchant.name }}</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <select class="form-control" v-model="formData.acquirer_id">
                                            <option value="">-- Выберите банк --</option>
                                            <option v-for="acquirer in acquirers" :value="acquirer.id">{{ acquirer.short_name }}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <button class="btn btn-primary" type="submit" :disabled="focused">Скачать</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </header>
    </div>
</template>

<script>
    export default {
        name: "Reports",
        data() {
            return {
                focused: false,
                dateRange: null,
                formData: {
                    type: '',
                    merchant_id: '',
                    acquirer_id: '',
                    range_start: null,
                    range_end: null
                },
                merchants: [],
                types: [],
                acquirers: [],
            }
        },
        created() {
            this.getMerchants();
            this.getTypes();
            this.getAcquirers();
        },
        methods: {
            getAcquirers() {
                axios.get('/admin/payment/acquiring')
                    .then(response => {
                        this.acquirers = response.data;
                    })
            },
            getMerchants() {
                axios.get('/admin/ajax/merchants')
                    .then(response => {
                        this.merchants = response.data;
                    })
            },
            getTypes() {
                axios.get('/admin/ajax/types')
                    .then(response => {
                        this.types = response.data;
                    })
            },
            reportDownload () {
                this.$store.commit('setLoading');
                this.formData.range_start = this.dateRange.start.replace(/'/g, "");
                this.formData.range_end = this.dateRange.end.replace(/'/g, "");
                axios.get('/admin/report/export', {params: this.formData, responseType: 'blob'})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.types[this.formData.type] + '-' + this.acquirers[this.formData.acquirer_id - 1]['short_name'] + ' c ' + this.formData.range_start + ' по ' + this.formData.range_end + '.zip');
                        document.body.appendChild(link);
                        link.click();
                        this.$store.commit('unsetLoading');
                    })
                    .catch(function () {
                        alert('Отчеты не найдены');
                    });
            }
        }
    }
</script>

<style scoped>

</style>